import React, { useEffect, useMemo, useState } from 'react';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { apiHolder as api, apis, getIn18Text, skipWmClassify, skipWmOthClassify } from 'api';
import classnames from 'classnames';
import styles from './mailListTips.module.scss';
import { FLOLDER } from '@web-mail/common/constant';
import useUserLocalStorageState from '@web-mail/hooks/useUserLocalStorageState';
import { folderIdIsAllCustomerUnFollow, folderIdIsAllEdmReply, folderIdIsAllEdmOtherReply, folderIdIsAllUnFollow, isUnFollowFolder } from '@web-mail/util';
import { Tooltip } from 'antd';
import { TongyongYiwen } from '@sirius/icons';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { ANCHOR_ID_MAP } from '@web-setting/Mail/components/MailSetting/DefaultMailSettingConfig';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
const MAIL_EDM_TIP_HAS_CLOSE = 'MAIL_EDM_TIP_HAS_CLOSE';
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const EdmReplyTip = (props) => {
    const [selectedKeys] = useState2RM('selectedKeys');
    const [mailSearching] = useState2RM('mailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const [open, setOpen] = useState(false);
    const [configArr, setConfigArr] = useState([]);
    const [hasClose, setHasClose] = useUserLocalStorageState(MAIL_EDM_TIP_HAS_CLOSE, false);
    const [, setEdmFollowUpTipShow] = useState2RM('edmFollowUpTipShow');
    const [configMailVisible, setConfigMailVisible] = useState2RM('configMailShow', 'doUpdateConfigMailShow');
    const [configMailFocusId, setConfigMailFocusId] = useState2RM('configMailFocusId', 'doUpdateConfigMailFocusId');
    useEffect(() => {
        setEdmFollowUpTipShow(!!hasClose);
    }, [hasClose]);
    useEffect(() => {
        setOpen(false);
    }, [selectedKeys.id]);
    useEffect(() => {
        if (!configMailVisible) {
        }
    }, [configMailVisible]);
    const handleClick = () => {
        if (open) {
            setHasClose(true);
        }
        setOpen(!open);
    };
    const fetchConf = async () => {
        try {
            const res = await mailConfApi.getReplyAutoClassifyConf();
            setConfigArr([...(res[skipWmClassify] ? [skipWmClassify] : []), ...(res[skipWmOthClassify] ? [skipWmOthClassify] : [])]);
        }
        catch (error) {
            console.error('获取营销自动回复分类失败');
        }
    };
    useEffect(() => {
        fetchConf();
    }, []);
    useMsgRenderCallback('toSaveAutoClassify', () => fetchConf());
    const comeToOpen = () => {
        setConfigMailVisible(true);
        setTimeout(() => {
            setConfigMailFocusId(ANCHOR_ID_MAP.COMMON_AUTO_CLASSIFY);
            setTimeout(() => setConfigMailFocusId(''), 200);
        }, 200);
    };
    const edmCustomerReplyTip = useMemo(() => {
        if (isSearching) {
            return null;
        }
        else if (selectedKeys.id === FLOLDER.EDM_REPLY || folderIdIsAllEdmReply(selectedKeys.id)) {
            const val = configArr.includes(skipWmClassify);
            if (!val) {
                return (React.createElement("div", { className: styles.commonTip },
                    React.createElement("span", null, getIn18Text('TONGGUOXITSBYXRWDQZK20'))));
            }
            else {
                return (React.createElement("div", { className: classnames(styles.commonTip, styles.noOpen) },
                    React.createElement("p", null, getIn18Text('YINGXIAOQIANKHFYJZDF20')),
                    React.createElement("span", { className: styles.toOpen, onClick: comeToOpen }, getIn18Text('DIANCIQIANWKQ'))));
            }
        }
        else if (selectedKeys.id === FLOLDER.EDM_OTHER_REPLY || folderIdIsAllEdmOtherReply(selectedKeys.id)) {
            const othVal = configArr.includes(skipWmOthClassify);
            if (!othVal) {
                return (React.createElement("div", { className: styles.commonTip },
                    React.createElement("span", null, getIn18Text('TONGGUOXITSBYXRWDQTH19'))));
            }
            else {
                return (React.createElement("div", { className: classnames(styles.commonTip, styles.noOpen) },
                    React.createElement("p", null, getIn18Text('YINGXIAOQITHFYJZDFLN18')),
                    React.createElement("span", { className: styles.toOpen, onClick: comeToOpen }, getIn18Text('DIANCIQIANWKQ'))));
            }
        }
        else if (!hasClose && (selectedKeys.id === FLOLDER.CUSTOMER_UNFOLLOW || folderIdIsAllCustomerUnFollow(selectedKeys.id))) {
            return (React.createElement("div", { className: styles.commonTip },
                React.createElement("div", null,
                    React.createElement("span", { className: styles.commonTipTitle }, getIn18Text('SHENMESHIYDDGJ')),
                    React.createElement("span", { className: styles.commonTipBtn, onClick: handleClick }, open ? getIn18Text('SHOUQI') : getIn18Text('CHAKAN'))),
                !!open && React.createElement("span", { className: styles.commonTip2 }, getIn18Text('YIJIANDANGKHBKNJNTSD82'))));
        }
        else if (!hasClose && (selectedKeys.id === FLOLDER.UNFOLLOW || folderIdIsAllUnFollow(selectedKeys.id))) {
            return (React.createElement("div", { className: styles.commonTip },
                React.createElement("div", null,
                    React.createElement("span", { className: styles.commonTipTitle }, getIn18Text('SHENMESHIWDDGJ')),
                    React.createElement("span", { className: styles.commonTipBtn, onClick: handleClick }, open ? getIn18Text('SHOUQI') : getIn18Text('CHAKAN'))),
                !!open && React.createElement("span", { className: styles.commonTip2 }, getIn18Text('WEIJIANDANGKHBKNDTXL86'))));
        }
        else {
            return null;
        }
    }, [selectedKeys.id, isSearching, open, hasClose, configArr]);
    return edmCustomerReplyTip;
};
export const EdmFollowUpTip = () => {
    const [edmFollowUpTipShow] = useState2RM('edmFollowUpTipShow');
    const [selectedKeys] = useState2RM('selectedKeys');
    const [configMailLayout] = useState2RM('configMailLayout', 'doUpdateConfigMailLayout');
    const isLeftRight = useMemo(() => configMailLayout === '1', [configMailLayout]);
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const titleDom = useMemo(() => {
        const isCustomerUnFollow = selectedKeys.id === FLOLDER.CUSTOMER_UNFOLLOW || folderIdIsAllCustomerUnFollow(selectedKeys.id);
        return (React.createElement("div", { className: styles.commonTip3 },
            React.createElement("div", { style: { fontWeight: 600, marginBottom: 4 } }, isCustomerUnFollow ? getIn18Text('SHENMESHIYDDGJ') : getIn18Text('SHENMESHIWDDGJ')),
            React.createElement("div", { style: { opacity: 0.8, marginBottom: 8 } }, isCustomerUnFollow ? getIn18Text('YIJIANDANGKHBKNJNTSD47') : getIn18Text('WEIJIANDANGKHBKNDTXL51')),
            React.createElement("div", { style: { fontWeight: 600, marginBottom: 4 } }, getIn18Text('RUHEGENJCL')),
            React.createElement("div", { style: { opacity: 0.8, marginBottom: 8 } }, getIn18Text('NIKEDUILXHFSDBJWYGJH7')),
            React.createElement("div", { style: { fontWeight: 600, marginBottom: 4 } }, isCustomerUnFollow ? getIn18Text('YOUDANGDAIGJYSJXYSMG1') : getIn18Text('WUDANGDAIGJYSJXYSMGX')),
            React.createElement("div", { style: { opacity: 0.8 } }, isCustomerUnFollow ? getIn18Text('YOUDANGDAIGJDYJQZSJX15') : getIn18Text('WUDANGDAIGJDYJQZSJXN14'))));
    }, [selectedKeys.id]);
    const tipDom = useMemo(() => {
        if ((process.env.BUILD_ISEDM || navigateVersion) &&
            edmFollowUpTipShow &&
            (selectedKeys.id === FLOLDER.CUSTOMER_UNFOLLOW ||
                folderIdIsAllCustomerUnFollow(selectedKeys.id) ||
                selectedKeys.id === FLOLDER.UNFOLLOW ||
                folderIdIsAllUnFollow(selectedKeys.id))) {
            return (React.createElement(Tooltip, { title: titleDom, placement: "bottom", autoAdjustOverflow: true, overlayStyle: { width: 350, maxWidth: 350 } },
                React.createElement("div", { style: { display: 'flex', alignItems: 'center', marginRight: 12 } },
                    React.createElement(TongyongYiwen, { style: { width: 16, height: 16 }, wrapStyle: { width: 16, height: 16, display: 'flex', alignItems: 'center', marginRight: 4 } }),
                    !isLeftRight ? React.createElement("div", null, isUnFollowFolder(selectedKeys.id) ? getIn18Text('SHENMESHIWDDGJedbbui') : getIn18Text('SHENMESHIYDDGJft5ooz')) : React.createElement(React.Fragment, null))));
        }
        return null;
    }, [edmFollowUpTipShow, selectedKeys, titleDom, navigateVersion]);
    return tipDom;
};
export default EdmReplyTip;
